<template>
    <b-modal id="notificationSuccessfully" hide-footer hide-header centered>
        <div class="ml-2">
            <p class="modal-title ml-1">
                {{ $t('enps.modal.researchApplySucefully') }}
            </p>
            <p class="modal-paragraph mt-3">
                {{ $t('enps.modal.avaliableOnTheHomePage')
                }}<span class="link-ref" v-on:click="goToHome">{{ $t('enps.modal.home') }}</span
                >.
            </p>
            <p class="modal-paragraph">
                {{
                    $t('enps.modal.trackResponsesInReports', {
                        data: formatDate(expired_date),
                        hours: formatHour(expired_date),
                    })
                }}<span class="link-ref" v-on:click="goToReports">{{ $t('enps.modal.reports') }}</span
                >{{ $t('enps.modal.enpsSetupScreen') }}
            </p>
        </div>
        <div class="text-center">
            <b-button class="mr-1" variant="primary" @click="goToHome">
                {{ $t('enps.modal.button.goToHome') }}
            </b-button>
            <b-button variant="outline-primary" @click="goBackEnps">
                {{ $t('enps.modal.button.backToEnps') }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { getStringFromDateWithoutTime, formatDate } from '@/lib/date'
export default {
    name: 'AppliedModal',
    props: {
        expired_date: null,
    },
    methods: {
        formatDate(data) {
            return getStringFromDateWithoutTime(data, 'YYYY-MM-DD')
        },
        formatHour(data) {
            return formatDate(data, 'LT')
        },
        goToReports() {
            this.$router.push('/v2/reports/enps')
        },
        goToHome() {
            this.$router.push('/v2/home')
        },
        goBackEnps() {
            this.$bvModal.hide('notificationSuccessfully')
        },
    },
}
</script>

<style scoped lang="scss">
.modal-title {
    font-family: 'Roboto';
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    color: #022b4f;
}

.link-ref {
    color: #022b4f;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
}

.modal-paragraph {
    font-family: 'Roboto';
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0.002em;
    text-align: left;
    color: #3b3f4e;
}
</style>
